import { render, staticRenderFns } from "./schoolMine.vue?vue&type=template&id=4535af90&scoped=true&"
import script from "./schoolMine.vue?vue&type=script&lang=js&"
export * from "./schoolMine.vue?vue&type=script&lang=js&"
import style0 from "./schoolMine.vue?vue&type=style&index=0&id=4535af90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535af90",
  null
  
)

export default component.exports